const textColor = '#0E3356';

module.exports = {
  // craco-config
  primaryColor: '#0E3356',
  layoutBodyBackground: '#F5F7F9',
  textColor,
  textColorSecondary: '#4D4F5C',
  headingColor: textColor,
  borderRadiusBase: '4px',
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Nunito Sans', 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
  'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
  'Noto Color Emoji'`,
  successColor: '#50D8BB',
  warningColor: '#FECB2E',
  errorColor: '#FF6565',
  avatarBg: '#F5F7F9',
  avatarColor: textColor,
  // other
  balanceColorPosted: '#F1AE38',
  balanceColorAvailable: '#8D2CBA',
  balanceColorPending: '#01CD98',
};
